import { render, staticRenderFns } from "./DoacFollowupTool.vue?vue&type=template&id=db5b76c6&"
import script from "./DoacFollowupTool.vue?vue&type=script&lang=js&"
export * from "./DoacFollowupTool.vue?vue&type=script&lang=js&"
import style0 from "./DoacFollowupTool.vue?vue&type=style&index=0&id=db5b76c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports